import styles from './TotalAcc.module.css'
import { useState } from 'react';
import LineChart from './LineChart'
import { COLORS } from './constant';
import { useEffect } from 'react';

export default function TotalAcc({
    dashboardData,
    modelList,
    checkedModels,
    testSetList,
    checkedTests,
    setExportData,
}){

    const [chartData, setChartData] = useState([]);
    const [visibleTests, setVisibleTests] = useState([]);

    useEffect(()=>{
        const newChartData = [];
        let colorCnt=0;
          
        dashboardData.forEach(item => {
            if (
                checkedModels.includes(item.modelId) &&
                checkedTests.includes(item.datasetId)
            ) {
                const testMeta = testSetList.find(t => t.datasetId === item.datasetId);
                const modelMeta = modelList.find(m => m.modelId === item.modelId);
          
                // const testName = testMeta ? testMeta.datasetName : 'Unknown Test';
                // const modelName = modelMeta ? modelMeta.modelName : 'Unknown Model';
          
                let testLine = newChartData.find(line => line.datasetId === testMeta.datasetId);
                if (!testLine) {
                    testLine = { datasetId: testMeta.datasetId, datasetName:testMeta.datasetName,color:COLORS[ colorCnt % COLORS.length] ,data: [] };
                    newChartData.push(testLine);
                }

                testLine.data.push({
                    x: modelMeta.displayName,
                    y: item.result?.accuracy ?? null,
                    z: item.result?.threshold ?? null,
                });

                colorCnt++;
            }
        });

        const displayOrder = modelList.map(m=>m.displayName);
        const sortedChartData=newChartData.map(item=>({
            ...item,
            data:displayOrder
                .map(name=>item.data.find(d=>d.x===name))
        }))

        setChartData(sortedChartData);
        setVisibleTests(sortedChartData.map(line => line.datasetId));
        setExportData(sortedChartData.filter(line => sortedChartData.map(line => line.datasetId).includes(line.datasetId)));
    },[dashboardData])

    const toggleTestLine = (testId) => {
        setVisibleTests(prev =>
            prev.includes(testId)
                ? prev.filter(id => id !== testId)
                : [...prev, testId]
        );
    };

    const displayedChartData = chartData.filter(line => visibleTests.includes(line.datasetId));

    return(
        <div className={styles['wrap']}>
            <header>
                <span>Total Accuracy</span>
                {
                    chartData.map((item,idx)=>(
                        <button 
                        className={styles['filter-btn']}
                        onClick={()=>toggleTestLine(item.datasetId)}
                        style={{opacity:displayedChartData.some(dispalyItem=>dispalyItem.datasetId===item.datasetId)?1:.4}}
                        >
                            <div 
                            className={styles['filter-btn-color']} 
                            style={{backgroundColor:item.color}}
                            />
                            <span>{item.datasetName}</span>
                        </button>
                    ))
                }
            </header>
            <div className={styles['body']}>
                <div className={styles['chart']}>
                    <LineChart data={displayedChartData}/>
                </div>
            </div>
        </div>
    )
}